// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"so-z","breadcrumbForward":"to-z","breadcrumbBack":"uo-z","selected":"vo-z"};